import NextLink from 'next/link'
import { useQueryParams } from 'ssr/router'
import { PaginationItem, Pagination as View } from 'ui-components'
import { getTagsQuery } from 'utils'
import { useSearchTags } from '~map-tags/queries/useSearchTags'

export function TagsPagination() {
  const { pagination } = useSearchTags()
  const queryParams = useQueryParams()

  return (
    <View
      {...pagination}
      renderItem={(item) => (
        <PaginationItem
          {...item}
          component={NextLink}
          href={getTagsQuery({ ...queryParams, page: item.page })}
        />
      )}
    />
  )
}
